import { RetailerFileSettings } from '@common/models';

import { staticContentService } from '../../static-content-api/staticContentService';

export type RetailerFileSettingsParams = {
    url: string;
};

/**
 * Service to fetch retailer file settings from a given URL.
 * This service uses the **static content service** to perform the API call.
 */
const retailerFileSettingsService = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchRetailerFileSettings: builder.query<RetailerFileSettings, RetailerFileSettingsParams>({
            query: ({ url }) => ({
                url,
                method: 'GET',
            }),
        }),
    }),
});

export const { useFetchRetailerFileSettingsQuery } = retailerFileSettingsService;
